<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_4865_2209)">
            <path
                d="M16 4L8 12L16 20"
                stroke="currentColor"
                stroke-width="3"
            />
        </g>
        <defs>
            <clipPath id="clip0_4865_2209">
                <rect
                    x="24"
                    y="24"
                    width="24"
                    height="24"
                    rx="12"
                    transform="rotate(180 24 24)"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
</template>

<script setup lang="ts"></script>
